import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper
} from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import { useAuth } from '../../components/auth/AuthContext';
import AdminTabs from '../../components/admin/AdminTabs';
import { APIHOST } from '../../../src/common';
import { Conference } from '../../types/conference';
import AvailabilityReport from './reports/AvailabilityReport';
import AvailabilityReportText from './reports/AvailabilityReportText'
import OrderReport from './reports/OrderReport';


export default function ReportsPage() {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const [reportType, setReportType] = useState('');
  const [conferences, setConferences] = useState<Conference[]>([]);

  const isAuthenticated = currentUser && (currentUser.userType === 'internal' || currentUser.userType === 'admin');

  useEffect(() => {
    if (isAuthenticated) {
      // User is authenticated with admin privileges
      fetch(`${APIHOST}/api/conferences`, {
          headers: {
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`
          }
          })
          .then(response => response.json())
          .then(data => {
            setConferences(data.data);
          })
          .catch(error => {
            console.error('Error fetching conferences:', error);
          });
    } else {
      navigate('/admin');
    }
    setLoading(false);
  }, []);

  const handleReportTypeChange = (event: SelectChangeEvent) => {
    setReportType(event.target.value);
  };


  if (loading) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  if (!isAuthenticated) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Alert severity="warning">
          Please log in to access this page.
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh', py: 4, mt: 8 }}>
      <Container maxWidth="lg">
        <AdminTabs currentPath="/admin/reports" />
        
        <Box sx={{ mt: 3 }}>
          <Paper sx={{ p: 3 }}>
            <FormControl fullWidth sx={{ mb: 3 }}>
              <InputLabel id="report-type-label">Report Type</InputLabel>
              <Select
                labelId="report-type-label"
                id="report-type-select"
                value={reportType}
                label="Report Type"
                onChange={handleReportTypeChange}
              >
                <MenuItem value="conference-availability">Conference Availability Report (Graph)</MenuItem>
                <MenuItem value="conference-availability-text">Conference Availability Report (Text)</MenuItem>
                <MenuItem value="order-report">Order Report</MenuItem>
              </Select>
            </FormControl>

            {reportType === 'conference-availability' && (
              <AvailabilityReport conferences={conferences} />
            )}

            {reportType === 'order-report' && (
              <OrderReport conferences={conferences} />
            )}

            {reportType === 'conference-availability-text' && (
              <AvailabilityReportText conferences={conferences} />
            )}

            {!reportType && (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <Typography variant="body1" color="text.secondary">
                  Please select a report type to begin.
                </Typography>
              </Box>
            )}
          </Paper>
        </Box>
      </Container>
    </Box>
  );
}